import { useMemo } from 'react'

import { useMyAssessmentAverages } from '../services/users.convex'
import { processLatestData } from '../utils/positionRadarChart.utils'
import { PositionRadarChart } from './PositionRadarChart'

/**
 * Radar chart for the currently authenticated user, sourced from Convex.
 *
 * No userId prop is required — identity is resolved server-side via the
 * Convex auth session. Use this on the user's own dashboard. For viewing
 * another user's data (e.g. a direct report), use ConnectedPositionRadarChart.
 */
export function ConvexPositionRadarChart() {
  const { data: timeseries, isLoading, error } = useMyAssessmentAverages(true)

  const chartData = useMemo(() => processLatestData(timeseries), [timeseries])

  return (
    <PositionRadarChart data={chartData} isLoading={isLoading} error={error} />
  )
}
